import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MainContent',
  components: {},
  props: {},
  methods: {},
});
